import PosthogService from '~/services/posthog/PosthogService';

export interface IActionNeededShiftViewShiftClickedPayload {
  shiftId: string;
  candidateCount: number;
}

/**
 * Fires when an office clicks on an action needed shift from the shift list
 * Event: dental_portal:action_needed_shift:view_shift_clicked
 */
export function fireActionNeededShiftViewShiftClicked(
  payload: IActionNeededShiftViewShiftClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:action_needed_shift:view_shift_clicked', {
    shift_id: payload.shiftId,
    candidate_count: payload.candidateCount,
  });
}
